// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevKidController {
	/* @ngInject */
	constructor() {
		this.data = 'K_NODE;PERSON';
		this.prefix = 'K_NODE';
		this.settings = {
			placeholder: 'My placeholder',
		};
		this.options = {
			button: 'genKid',
		};
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} item
	 */
	select(item) {
		// eslint-disable-next-line no-console
		console.log('select', item);
	}
}
